import { WidgetLoader } from 'datastake-daf/dist/components';

export default WidgetLoader;
